import _ from 'lodash';
import theme from 'client/styles/_export.scss';
import { COMPONENT_TYPE, CARD_ROOT_ELEMENT_INDEX as CREI } from 'common/constants';
import { isLayerType } from 'common/utils/is-layer-type';

const INDEX = {
	/*
		Above 201+
		Content 200
		Below 100-199
		BG 0-99
	*/
	[COMPONENT_TYPE.FLOAT_ABOVE]: parseInt(theme.zIndexFloatAbove, 10),
	[COMPONENT_TYPE.FLOAT_BELOW]: parseInt(theme.zIndexFloatBelow, 10),
};
// is float first level child
const isFFL = parent => [COMPONENT_TYPE.FLOAT_ABOVE, COMPONENT_TYPE.FLOAT_BELOW].includes(_.last(parent).type);
const baseIndex = componentType => INDEX[componentType];
// @ts-expect-error ts-migrate FIXME
const indexMax = (component = {}) => Math.max(0, _.size(component.children) - 1);
const computedIndex = (_baseIndex, _indexMax, index) => _baseIndex + _indexMax - index;
const findIndexOfGlobal = (component, sourceIndex, cardElements) =>
	_.findIndex(_.get(cardElements, [sourceIndex, 'children']), ['_id', component._id]);

/**
 * Assign z-index to reverse layers (first is above and next is below)
 *
 * In addition cares for a FLA|FLB first level children z-indexes
 * to maintain layers order correctly in case of global BB (storyElements) is exists
 *
 * @param element {object} building block data
 * @param isCardTree {boolean}
 * @param cardElements {array<object>}
 * @param index {number}
 * @param parent {array<object>}
 * @return {number|undefined}
 */
export function getElementZIndex({ element, isCardTree, cardElements, index, parent }) {
	if (!parent.length) {
		return undefined;
	}

	if (isFFL(parent)) {
		if (isCardTree && isLayerType(element).global) {
			return undefined; // skipped on render in traverseTree
		}

		const FLA_INDEX = CREI[COMPONENT_TYPE.FLOAT_ABOVE];
		const FLB_INDEX = CREI[COMPONENT_TYPE.FLOAT_BELOW];

		const FLA_MAX = indexMax(cardElements[FLA_INDEX]);
		const FLB_MAX = indexMax(cardElements[FLB_INDEX]);

		const FLOAT_TYPE = _.last(parent).type;
		const FLOAT_INDEX = FLOAT_TYPE === COMPONENT_TYPE.FLOAT_ABOVE ? FLA_INDEX : FLB_INDEX;
		const FLOAT_MAX = FLOAT_TYPE === COMPONENT_TYPE.FLOAT_ABOVE ? FLA_MAX : FLB_MAX;
		const ORIG_INDEX = isCardTree ? index : findIndexOfGlobal(element, FLOAT_INDEX, cardElements);

		return computedIndex(baseIndex(FLOAT_TYPE), FLOAT_MAX, ORIG_INDEX);
	}

	return 100 - index;
}
